module.exports = __webpack_public_path__ + "static/media/nodejs.2a96eda7.webp";